function AccountsResetPassCtrl($scope, $state, $rootScope, $q, $window, toastr, UserService, AuthService, AppSettings) {
    'ngInject';

    const vm = this;

    $scope.vm = vm;

    vm.isMobile = window.mobilecheck();

    const currentYear = (new Date()).getFullYear();

    vm.years = _.range(1940, currentYear);
    vm.months = _.range(1, 13);
    vm.dates = _.range(1, 32);

    vm.resetPassData = {
        login_id: null,
        name: null,
        birth: null,
        birthdate: {
            year: '' + (currentYear - 20),
            month: '1',
            date: '1'
        }
    };

    // 생년월일 변경
    $scope.$watchCollection('vm.resetPassData.birthdate', function (newVal, oldVal) {
        if (newVal.year && newVal.month && newVal.date) {
            let month = newVal.month;
            let date = newVal.date;

            if (month < 10) {
                month = '0' + month;
            }
            if (date < 10) {
                date = '0' + date;
            }

            vm.resetPassData.birth = newVal.year + month + date;
        }
    });

    vm.submit = function () {
        UserService.resetPass(vm.resetPassData).then(function (res) {
            if (res.data.result === 'NOT') {
                toastr.error('아이디가 존재하지 않습니다.');
            } else if (res.data.result === 'NO_ID') {
                toastr.error('로그인 아이디가 없는 사용자입니다.');
            } else {
                UserService.sendPass(vm.resetPassData);
                toastr.success('비밀번호가 메일로 발송되었습니다. 메일을 확인하시기 바랍니다.');
            }
        });
    };

}

export default {
    name: 'AccountsResetPassCtrl',
    fn: AccountsResetPassCtrl
};
